import { appHttpClient } from "../../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../../installations/http/inFlight";

export const addPriceList = (data) => {
    return appHttpClient.post(`/PriceList/Add`, data);
};

export const updatePriceList = (data) => {
    return appHttpClient.post(`/PriceList/Update`, data);
};

export const deletePriceList = (priceListId) => {
    return appHttpClient.delete(`/PriceList/Delete/${priceListId}`);
};

export const getPriceLists = (queryParams) => {
    // 0016: dedupe StrictMode double-invoke; key on the params so different queries fetch independently.
    return dedupeRequest(`priceLists:${JSON.stringify(queryParams || {})}`, () =>
        appHttpClient.get(`/PriceList/GetAll`, { params: queryParams })
    );
};
export const addPrice = (data) => {
    return appHttpClient.post(`/PriceList/Price/Add`, data);
};

export const updatePrice = (data) => {
    return appHttpClient.post(`/PriceList/Price/Update`, data);
};

const priceListService = {
    addPriceList,
    updatePriceList,
    deletePriceList,
    getPriceLists,
    addPrice,
    updatePrice,
};

export default priceListService;